enum FetchMethod {
  POST = 'POST',
  GET = 'GET',
  PATCH = 'PATCH',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  PUT = 'PUT',
}

export default FetchMethod;
